import { registerAthleteWithEventId } from "./AthleteService";

export async function GetIntellipayWidget(apiInstance) {
  try {
    const response = await apiInstance.get(`/Payment/intellipay-widget`);
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false };
  }
}
export async function PostPayment(apiInstance, postData) {
  try {
    const response = await apiInstance.post(`/payment/saverecord`, postData, {
      meta: {
        delayMs: 1000,
        retry: true,
        maxRetries: 1,
        allowRetryOnPost: true,
        timeoutMs: 60000,
      },
    });

    return response;
  } catch (err) {
    throw new Error(`PostPayment failed: ${err.message}`);
  }
}

// No retry meta, unlike PostPayment: a retried bundle purchase would insert a
// second set of payment rows.
export async function purchaseCombineBundle(apiInstance, postData) {
  try {
    const response = await apiInstance.post(
      `/payment/combine-bundle`,
      postData,
      {
        meta: { timeoutMs: 60000 },
      },
    );
    return response;
  } catch (err) {
    throw new Error(
      err.response?.data?.error ||
        `purchaseCombineBundle failed: ${err.message}`,
    );
  }
}

// Registers the athlete for the originally selected combine, then buys the
// bundle once. POST /payment/combine-bundle registers the remaining combines,
// grants position drills wherever offered, and writes one payment row per
// combine — so no PostPayment calls (and no separate drill purchase) here.
export async function registerAndPurchaseCombineBundle(
  apiInstance,
  { user, eventId, bundle, transactionId = "", intellipayToken = "" },
) {
  let registration;
  try {
    registration = await registerAthleteWithEventId(apiInstance, user, eventId);
  } catch (err) {
    throw new Error(err?.error || "Athlete spot registration failed.");
  }
  if (registration?.status !== 200) {
    throw new Error("Athlete spot registration failed.");
  }

  const purchase = await purchaseCombineBundle(apiInstance, {
    userId: registration.data.id,
    combineBundleId: bundle.bundleId,
    eventId: Number(eventId),
    amount: Number(bundle.bundlePrice ?? 0),
    transactionId,
    intellipayToken,
    isCash: false,
    tShirtSize: user?.tshirtSize || null,
  });
  if (purchase?.status !== 200) {
    throw new Error("Combine bundle purchase failed.");
  }
}

export const clearCombineBundleCheckoutStorage = () => {
  localStorage.removeItem("appliedCouponCode");
  localStorage.removeItem("appliedCouponData");
  localStorage.removeItem("appliedCouponType");
  localStorage.removeItem("subscriptionDetails");
  localStorage.removeItem("bundleDetails");
  localStorage.removeItem("registeredAccount");
};

export const getCombineBundleSuccessMessage = (bundle) => {
  const combines = Array.isArray(bundle?.combines) ? bundle.combines : [];
  const names = combines.map((combine) => combine?.name).filter(Boolean);
  const list =
    names.length > 1
      ? `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`
      : names[0] || "your combines";
  const drills = combines.some((combine) => combine?.hasPositionDrills)
    ? " Position drills are included at the combines that offer them."
    : "";
  return `You're registered for ${list}.${drills}`;
};

export async function GetCashToken(apiInstance) {
  try {
    const response = await apiInstance.get(`/Payment/cash-token`);
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false };
  }
}

export async function CheckValidCashToken(apiInstance, tokenGuid) {
  try {
    const response = await apiInstance.get(`/Payment/is-valid-cash-token`, {
      params: { tokenGuid },
    });
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false };
  }
}
export async function PostIntellipayStoreSuccess(apiInstance, intellipayToken) {
  try {
    const response = await apiInstance.post(`/Payment/store-success`, null, {
      params: { intellipayToken },
    });

    return { success: true, data: response.data };
  } catch (err) {
    console.error("Error response:", err.response?.data || err);
    return { success: false, error: err.response?.data };
  }
}

export async function UpdateIntellipayCardInfo(apiInstance, putData) {
  try {
    const response = await apiInstance.put(`/Payment/cust-update`, putData);
    return response;
  } catch (err) {
    return { success: false };
  }
}

export async function CreateSubscriptionDetails(apiInstance, objSubscription) {
  try {
    const response = await apiInstance.post(
      `/Payment/cust-update`,
      objSubscription,
    );
    return response;
  } catch (err) {
    return { success: false };
  }
}

export async function GetSubscriptionDetails(apiInstance) {
  try {
    const response = await apiInstance.get(`/Payment/subscription-details`);
    return response;
  } catch (err) {
    return { success: false };
  }
}

export const deleteUserSubscription = async (apiInstance) => {
  try {
    const response = await apiInstance.delete(`/Payment/subscription`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const StartFreeTrial = async (apiInstance, userId) => {
  try {
    const res = await apiInstance.post(`/payment/${userId}/start-free-trial`);
    return { success: true, data: res.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const GrantFreeSubscription = async (apiInstance, userId, days) => {
  try {
    const response = await apiInstance.post(
      `/payment/${userId}/free-subscription`,
      { days },
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};
